import { ACTION_TYPES } from "../constants/actionTypes";
import { NotificationManager } from 'react-notifications';
import { saveReport, fetchReports,editReport, deleteReport }   from "../API";

export const addReport =(res)=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.SAVE_REPORT_REQUEST})
        const {data} = await saveReport(res);
        dispatch({type: ACTION_TYPES.SAVE_REPORT_SUCCESS, payload:data.data})
        dispatch(getReport())
    }
    catch(err){
        console.log(err)
        dispatch({type: ACTION_TYPES.SAVE_REPORT_FAILED})
        NotificationManager.error(err.message)
    }
}

export const getReport =()=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.FETCH_REPORT_REQUEST})
        const {data} = await fetchReports()
        dispatch({type: ACTION_TYPES.FETCH_REPORT_SUCCESS, payload:data.data})
    }
    catch(err){
        console.log(err.message)
        dispatch({type: ACTION_TYPES.FETCH_REPORT_FAILED})
        NotificationManager.error(err.message)
    }
}

export const setReport =(res)=>async(dispatch, getState)=>{   
    try{
        dispatch({type: ACTION_TYPES.SET_REPORT_REQUEST})
        console.log("res", res)
        dispatch({type: ACTION_TYPES.SET_REPORT_SUCCESS, payload:res})
    }
    catch(err){
        console.log(err.message);
        dispatch({type:ACTION_TYPES.SET_REPORT_FAILED})
        NotificationManager.error(err.response ? err.response.data.msg : err.message)
    }
}

export const updateReport = (id, res)=> async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.EDIT_REPORT_REQUEST})
        const {data} = await editReport(id, res)
        dispatch({type: ACTION_TYPES.EDIT_REPORT_SUCCESS, payload:data.data})
    }
    catch(err){
        console.log(err)
        dispatch({type: ACTION_TYPES.EDIT_REPORT_FAILED})
        NotificationManager.error(err.message)
    }
}

export const deleteReportData =(reportId)=>async(dispatch, getState)=>{
    try{
        dispatch({type: ACTION_TYPES.DELETE_REPORT_REQUEST})
        const {data} = await deleteReport(reportId)
        dispatch({type: ACTION_TYPES.DELETE_REPORT_SUCCESS})
        NotificationManager.success(data.msg) 
        dispatch(getReport())
    }
    catch(err){
        console.log(err.message)
        dispatch({type: ACTION_TYPES.DELETE_REPORT_FAILED})
        NotificationManager.error(err.message)
    }
}